import { render } from "./HubItem.vue?vue&type=template&id=76d9c0b0&ts=true"
import script from "./HubItem.vue?vue&type=script&lang=ts"
export * from "./HubItem.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/HubItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76d9c0b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76d9c0b0', __exports__)) {
    api.reload('76d9c0b0', __exports__)
  }
  
  module.hot.accept("./HubItem.vue?vue&type=template&id=76d9c0b0&ts=true", () => {
    api.rerender('76d9c0b0', render)
  })

}


export default __exports__